import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { SessionService } from "../session";

export const rootGuard: CanActivateFn = async (route, state) => {
    const router = inject(Router);
    const sessionService = inject(SessionService);

    if (!["/admin", "/"].includes(state.url)) return true;

    const redirectUrl = sessionService.getDefaultRouteForActiveRole();

    return router.parseUrl(redirectUrl);
};
